var render = function render(){var _vm=this,_c=_vm._self._c;return _c('lazy-alert-box',{staticClass:"mb-2",attrs:{"bg-color":"bg-robin","text-color":"text-robin-150"}},[_c('p',[_vm._v("\n    There are upcoming changes to your billing at the end of the current billing cycle. Please\n    check your GitHub billing page for more updates.\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }